import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import InDmAvatar from '@/client/components/_atoms/in_dm_avatar'
import InDmDate from '@/client/components/_atoms/in_dm_date'
import InDmMessage from '@/client/components/_atoms/in_dm_message'
import InDmCard from '@/client/components/_molecules/in_dm_card'
import InDmMedia from '@/client/components/_molecules/in_dm_media'

import type { InDmChatItem } from './types'

interface Props {
  item: InDmChatItem
  showAvatar: boolean
  pictureUrl: string | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InDmChatRow',
  props: {
    item: null,
    showAvatar: { type: Boolean },
    pictureUrl: null
  },
  setup(__props: any) {

const props = __props as {
  item: InDmChatItem
  showAvatar: boolean
  pictureUrl: string | null
};



const AVATAR_SIZE = 28

const isReceive = computed(
  () =>
    (props.item.type === 'message' && props.item.side === 'left') ||
    props.item.type === 'media' ||
    props.item.type === 'card'
)

return { __sfc: true,props, AVATAR_SIZE, isReceive, InDmAvatar, InDmDate, InDmMessage, InDmCard, InDmMedia }
}

})